import type { IClientMinimal } from "@/api/clients/clients.types";

import { useConversationDetail } from "./useConversationDetail";

export type ConversationClient = {
    clientId: number | undefined;
    client: IClientMinimal | undefined;
};

/**
 * Read the current conversation's client tag (`client_id` / `client`) off
 * the same ConversationDetail query that `useAccessMode` and
 * `useConversationAgent` already warm, so mounting this hook alongside
 * them incurs no extra network round-trip.
 *
 * Pending and error states return `{ undefined, undefined }` so the
 * obvious caller pattern (`client ? <Chip /> : null`) renders nothing
 * until the value is known. Same fail-closed posture as the access-mode
 * gate; no optimistic render.
 */
export function useConversationClient(
    remoteId: number | string | undefined
): ConversationClient {
    const { data } = useConversationDetail(remoteId);

    if (!data) {
        return { clientId: undefined, client: undefined };
    }
    return {
        clientId: data.client_id ?? undefined,
        client: data.client ?? undefined,
    };
}
